import { combineReducers } from 'redux';

import items from './items';
import links from './links';
import page from './page';

/**
 * @typedef {{
 *  page: import('modules/global/generic.types.js').Page,
 *  links: Array<import('modules/global/generic.types.js').Link>,
 *  items: Array<import('modules/statistics/types').SelfServiceTopContributors>
 * }} StatisticsSelfServiceTopContributorDataReducer
 */

export default combineReducers({
  page,
  items,
  links,
});
